export default "__VITE_ASSET__CtLoZE3m__"